// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2eoYn","rightAdornment":"Header_rightAdornment__2hz-E"};